import jquery from 'jquery'
window.jQuery = jquery
window.$ = jquery

// Set CSRF-Token for HTTP requests
$.ajaxSetup({
  headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
})
